const version = '(v2.20.11.16)'

export default version
